import { render, staticRenderFns } from "./VRApp.vue?vue&type=template&id=244a30d0&scoped=true&lang=pug&"
import script from "./VRApp.vue?vue&type=script&lang=js&"
export * from "./VRApp.vue?vue&type=script&lang=js&"
import style0 from "./VRApp.vue?vue&type=style&index=0&id=244a30d0&lang=postcss&scoped=true&"
import style1 from "./VRApp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a30d0",
  null
  
)

export default component.exports